export { default as arrayCache } from './cache/arrayCache';
export { default as objectCache } from './cache/objectCache';
export { default as buildStaticAssetUrl } from './buildStaticAssetUrl';
export { default as isDevelopment } from './isDevelopment';
export * from './styling';
export { default as abbreviateNumber } from './abbreviateNumber';
export { default as downloadFile } from './downloadFile';
export { default as getGravatarUrl } from './getGravatarUrl';
export { default as relativeRound } from './relativeRound';
export * from './HeadingLevelContext';
export { default as cond } from './cond';
export { default as ensureArray } from './ensureArray';
export { default as copyTextToClipboard } from './copyTextToClipboard';
export { default as isAdminRole } from './isAdminRole';
export { default as isEmailAddressValid } from './isEmailAddressValid';
export { default as slugify } from './slugify';
export { default as pluralize } from './pluralize';
export { default as infinitize } from './infinitize';
export { default as isProduction } from './isProduction';
export { default as isBrowser } from './isBrowser';
export { default as getInitialsFromString } from './getInitialsFromString';
export { default as getCookie } from './getCookie';
export { default as setCookie } from './setCookie';
export { default as prefixWithArticle } from './prefixWithArticle';
import * as serviceUtils from './services';
export { serviceUtils };
export * from './spacing';
export { isInIframe, isInPopup, isOffSite } from './environment';
export { default as weightedSearch } from './weightedSearch';
export { default as createKeyHandler } from './createKeyHandler';
export { default as createReducer } from './createReducer';
export { default as keyCodes } from './keyCodes';
export { default as hexToRrggbbaa } from './hexToRrggbbaa';
export * from './pushToDataLayer';
export { default as formatTotalCount } from './formatTotalCount';
export { default as safeStringify } from './safeStringify';
export { default as cleanServiceClassname } from './services/cleanServiceClassname';
export { default as binToStr } from './binToStr';
export { default as strToBin } from './strToBin';
export { default as superHumanize } from './superHumanize';

/*
 * Stubbed type definitions for TypeScript consumers.
 * If you import `common-utils` in TS and need another method stubbed,
 * just add it to this file. Once the const/function declared here
 * is migrated to TS, remove this stub
 */
export declare const convertHtmlAstToReactElements: (
  ast: any,
  transform: any,
  name?: string
) => any;
export declare const isEmptyString: (value: string) => boolean;
export declare const isZapTemplateNode: (node: any) => boolean;
export declare const isYoutubeNode: (node: any) => boolean;
export declare const toLowerCaseString: (thing: any) => string;
export declare const fuzzysearch: (needle: string, haystack: string) => boolean;
export declare const snakeCaseKeysDeep: (object: {
  [key: string]: any;
}) => { [key: string]: any };
export declare const createPopupSplash: () => Promise<Window>;
export declare type Keys = string | string[];
export declare function sendFormData(
  url: string,
  formData: FormData,
  // It should be RequestInit, but dts-bundle-generator doesn't translate it
  // opts?: RequestInit
  opts?: any
): Promise<any>;
export type HTMLAST = any;
export declare function uid(key?: string, length?: number): string;

export declare function exists(thing: any, ...rest: Keys[]): boolean;
export declare function parseSeparatedList(list: string): string[];
